import { Container, Row, Col } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import http from '../common/services/HttpService';
import { json } from 'react-router-dom';

const Auth = () => {
  return (
    <>
      <Container className="py-4">
        <Row className="vh-100 d-flex justify-content-center align-items-center">
          <Col md={8} lg={6} xs={12}>
            <Outlet />
          </Col>
        </Row>
      </Container>
    </>
  );
};


export const GuastLoader = async () => {
  try {
    const res = await http.get('/users/me?isWeb=true');
    if(res){
      throw new Response('', { status: 200 });
    }
    
  } catch (error: any) {
    if(error && error.status !== 200){
      return json('', { status: 200 }); 
    }
  }
}

export default Auth;
